import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export default function ContactSection() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent — we'll be in touch shortly.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    "w-full bg-[#0b1322] border border-white/15 rounded-xl px-4 py-3 text-sm text-white focus:border-[#1e9bff] outline-none transition-colors";

  return (
    <section id="contact" className="bg-[#0b1322] text-[#f0f4f8] py-24 md:py-32 border-b border-[#1e9bff]/15" data-testid="contact-section">
      <div className="max-w-4xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        <div>
          <span className="text-xs font-mono-lbl uppercase tracking-[0.2em] text-[#1e9bff] block mb-2">Get In Touch</span>
          <h2 className="font-display uppercase text-white text-[clamp(28px,3.5vw,44px)] leading-none mb-4">
            Send Us a Message
          </h2>
          <p className="text-sm text-[#93b4d4]">
            Questions about a job, access, or anything else? Drop us a line and we'll reply as soon as we can.
          </p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <input required minLength={2} placeholder="Your name" data-testid="contact-name-input" className={inputCls}
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input required type="email" placeholder="Email" data-testid="contact-email-input" className={inputCls}
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input type="tel" placeholder="Phone (optional)" data-testid="contact-phone-input" className={inputCls}
              value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <textarea required minLength={5} rows={4} placeholder="Your message" data-testid="contact-message-input" className={inputCls}
            value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          <button type="submit" disabled={sending} data-testid="contact-submit-btn"
            className="w-full py-3.5 rounded-xl bg-[#1e9bff] text-black font-display uppercase tracking-wider hover:bg-[#60baff] transition-colors disabled:opacity-50">
            {sending ? "Sending…" : "Send Message"}
          </button>
        </form>
      </div>
    </section>
  );
}
